import { NAVBAR_ITEM_SELECTED } from "./action-types"

export const itemSelected = (index, path) => ({
    type: NAVBAR_ITEM_SELECTED,
    index,
    path
})
